import * as EmailValidator from 'email-validator';

export const isValidEmail = (email: string) => EmailValidator.validate(email);
